import { render, staticRenderFns } from "./insurance_membership_form.vue?vue&type=template&id=6809a4d4&"
import script from "./insurance_membership_form.vue?vue&type=script&lang=js&"
export * from "./insurance_membership_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports